export default {
  "systemSetting.roles.section.collectionTypes": "Collection Types",
  "systemSetting.roles.section.singleTypes": "Single Types",
  "systemSetting.roles.section.plugins": "Plugins",
  "systemSetting.roles.section.settings": "Settings",
  "systemSetting.roles.actions.create": "Create",
  "systemSetting.roles.actions.read": "Read",
  "systemSetting.roles.actions.update": "Update",
  "systemSetting.roles.actions.delete": "Delete",
  "systemSetting.roles.actions.publish": "Publish",
  "systemSetting.roles.loadFailed": "Failed to load permissions",
  "systemSetting.roles.simple.empty": "No operations available",
  "systemSetting.roles.selectAll": "Select all",
  "systemSetting.roles.fields": "Fields",
  "systemSetting.roles.allSubjects": "All Subjects",
  "systemSetting.roles.content.empty": "No content types available",
  "systemSetting.roles.emptyData": "No permissions data",
  "systemSetting.roles.noSections": "No permission sections available",
  "systemSetting.roles.general": "General",
  "systemSetting.roles.generalLower": "general",

  //权限分类Title 
  
  "systemSetting.roles.section.plugins.strapi-cache": "ClearCach Plugin",
  "systemSetting.roles.section.plugins.user-admin-plugin": "User Menu Admin",

  //用户菜单权限管理 组名 subGroup 
  "systemSetting.roles.subGroup.user-admin": "User Admin Group",
  "systemSetting.roles.subGroup.withdraw-admin": "Withdraw Admin",
  "systemSetting.roles.subGroup.record-admin": "Record Admin",
  "systemSetting.roles.subGroup.bonus-admin": "Bonus Admin",
  "systemSetting.roles.subGroup.statistical-reports": "Statistical Reports",
  "systemSetting.roles.subGroup.agent-admin": "Agent Admin",
  "systemSetting.roles.subGroup.config-section": "Config Section",
  "systemSetting.roles.subGroup.game-admin": "Game Admin",
  "systemSetting.roles.subGroup.gem-mall-admin": "Gem Mall Admin",
  "systemSetting.roles.subGroup.pwa-notification-admin": "Pwa Notification Admin",
  "systemSetting.roles.subGroup.payment-admin": "Payment Admin",
  "systemSetting.roles.subGroup.system-setting": "System Setting",

  "systemSetting.roles.permissions": "Permissions",
  "systemSetting.roles.section.plugins.content-manager": "Content Manager",
  "systemSetting.roles.section.plugins.content-type-builder": "Content Type Builder",
  "systemSetting.roles.section.plugins.upload": "Upload",
  "systemSetting.roles.section.plugins.seo": "SEO Plugin",
  "systemSetting.roles.section.plugins.users-permissions": "Users Permissions",

  "systemSetting.roles.section.settings.email": "Email",
  "systemSetting.roles.section.settings.media library": "Media Library",
  "systemSetting.roles.section.settings.Internationalization": "Internationalization",
  "systemSetting.roles.section.settings.plugins and marketplace": "Plugins And Marketplace",
  "systemSetting.roles.section.settings.webhooks": "Web Hooks",
  "systemSetting.roles.section.settings.users and roles": "Users And Roles",
  "systemSetting.roles.section.settings.api tokens": "Api Tokens",
  "systemSetting.roles.section.settings.project": "Project",
  "systemSetting.roles.section.settings.transfer tokens": "Transfer Tokens",


  "systemSetting.roles.section.plugins.user-admin": "Member Management",
  "systemSetting.roles.section.settings.users-permissions": "Users & Permissions",
  "systemSetting.roles.subGroup.single types": "Single Types",
  "systemSetting.roles.action.plugin::content-manager.single-types.configure-view":
    "Configure view",

  
  //缓存插件权限管理 具体字段
  "systemSetting.roles.action.plugin::strapi-cache.purge-cache": "Setting ClearCache",
  //用户菜单权限管理 具体字段
  "systemSetting.roles.action.plugin::user-admin-plugin.setting-clear-cache.read": "Clear Cache Menu",
  "systemSetting.roles.action.plugin::user-admin-plugin.user-admin.read": "User Admin Menu",
  "systemSetting.roles.action.plugin::user-admin-plugin.user-admin-user-list.read": "User List Menu",
  "systemSetting.roles.action.plugin::user-admin-plugin.export-user-list.read": "Export User List",
  "systemSetting.roles.action.plugin::user-admin-plugin.user-admin-user-risk-admin.read": "User Risk Admin",
  "systemSetting.roles.action.plugin::user-admin-plugin.user-admin-user-tags-admin.read": "User Tags Admin",
  "systemSetting.roles.action.plugin::user-admin-plugin.user-admin-user-group-admin.read": "User Group Admin",
  "systemSetting.roles.action.plugin::user-admin-plugin.user-admin-user-vip-admin.read": "User Vip Admin",

  //资金管理菜单权限管理 具体字段
  "systemSetting.roles.action.plugin::user-admin-plugin.withdraw-admin.read": "Withdraw Admin Menu",
  "systemSetting.roles.action.plugin::user-admin-plugin.withdraw-admin-withdraw-approval-auto-withdraw.read": "Show Auto Withdraw",
  "systemSetting.roles.action.plugin::user-admin-plugin.withdraw-admin-withdraw-approval-auto-withdraw.edit": "Approval Auto Withdraw",
  "systemSetting.roles.action.plugin::user-admin-plugin.withdraw-admin-withdraw-approval.read": "Withdraw Approval List",
  "systemSetting.roles.action.plugin::user-admin-plugin.withdraw-admin-withdraw-history.read": "Withdraw History",
  "systemSetting.roles.action.plugin::user-admin-plugin.withdraw-admin-deposit-record.read": "Deposit Record",
   "systemSetting.roles.action.plugin::user-admin-plugin.export-deposit-record.read": "Export Deposit Record",
  "systemSetting.roles.action.plugin::user-admin-plugin.withdraw-admin-wallet-record.read": "Wallet Record",

  //记录管理菜单权限管理 具体字段
  "systemSetting.roles.action.plugin::user-admin-plugin.record-admin.read": "Record Admin",
  "systemSetting.roles.action.plugin::user-admin-plugin.record-admin-wallet-change-list.read": "Wallet Change List",
  "systemSetting.roles.action.plugin::user-admin-plugin.record-admin-bet-order.read": "Bet Order",
  "systemSetting.roles.action.plugin::user-admin-plugin.record-admin-bonus-record.read": "Bonus Record",
  "systemSetting.roles.action.plugin::user-admin-plugin.record-admin-redemption-code.read": "Redemption Code",
  "systemSetting.roles.action.plugin::user-admin-plugin.record-admin-checkin-record.read": "Checkin Record",
  "systemSetting.roles.action.plugin::user-admin-plugin.record-admin-freespin-record": "Freespin Record",
  "systemSetting.roles.action.plugin::user-admin-plugin.record-admin-luckywheel-record.read": "Luckywheel Record",
  "systemSetting.roles.action.plugin::user-admin-plugin.record-admin-activity-bonus-record.read": "Activity Bonus Record",
  "systemSetting.roles.action.plugin::user-admin-plugin.record-admin-login-history.read": "Login History",
   "systemSetting.roles.action.plugin::user-admin-plugin.record-admin-sms-history.read": "SMS History",
  "systemSetting.roles.action.plugin::user-admin-plugin.record-admin-operation-record.read": "Operation Record",

  //优惠管理菜单权限管理 具体字段
  "systemSetting.roles.action.plugin::user-admin-plugin.bonus-admin.read": "Bonus Admin Menu",
  "systemSetting.roles.action.plugin::user-admin-plugin.bonus-admin-promotions-admin.read": "Promotions Admin",
  "systemSetting.roles.action.plugin::user-admin-plugin.bonus-admin-bonus-approval.read": "Bonus Approval",
  "systemSetting.roles.action.plugin::user-admin-plugin.bonus-admin-activity-bonus-history.read": "Activity Bonus History",
  "systemSetting.roles.action.plugin::user-admin-plugin.bonus-admin-redemption-code-config.read": "Redemption Rode Config",
  "systemSetting.roles.action.plugin::user-admin-plugin.bonus-admin-free-spin-admin.read": "Free Spin Admin",
  "systemSetting.roles.action.plugin::user-admin-plugin.bonus-admin-luckywheel-admin.read": "Luckywheel Admin",
  "systemSetting.roles.action.plugin::user-admin-plugin.bonus-admin-activity-bonus-admin.read": "Activity Bonus Admin",
  "systemSetting.roles.action.plugin::user-admin-plugin.bonus-admin-daily-rebate-admin.read": "Daily Rebate Admin",
  "systemSetting.roles.action.plugin::user-admin-plugin.bonus-admin-realtime-rebate-admin.read": "Realtime Rebate Admin",
  "systemSetting.roles.action.plugin::user-admin-plugin.bonus-admin-invite-box-admin.read": "Invite Box Admin",
  "systemSetting.roles.action.plugin::user-admin-plugin.bonus-admin-task-admin.read": "Task Admin",
  "systemSetting.roles.action.plugin::user-admin-plugin.bonus-admin-luckydraw-config.read": "Luckydraw Config",

  //统计报表菜单权限管理 具体字段
  "systemSetting.roles.action.plugin::user-admin-plugin.statistical-reports.read": "Statistical Reports Menu",
  "systemSetting.roles.action.plugin::user-admin-plugin.statistical-reports-daily-reports.read": "Daily Reports",
  "systemSetting.roles.action.plugin::user-admin-plugin.statistical-reports-user-reports.read": "User Reports",
  "systemSetting.roles.action.plugin::user-admin-plugin.statistical-reports-channel-reports.read": "Channel Reports",
  "systemSetting.roles.action.plugin::user-admin-plugin.statistical-reports-ltv-reports.read": "LTV Reports",
  "systemSetting.roles.action.plugin::user-admin-plugin.statistical-reports-k-factor": "K-Factor Reports",
  "systemSetting.roles.action.plugin::user-admin-plugin.statistical-reports-retention-rate.read": "Retention Rate",
  "systemSetting.roles.action.plugin::user-admin-plugin.statistical-reports-retention-rate-bet.read": "Retention Rate(bet)",
  "systemSetting.roles.action.plugin::user-admin-plugin.statistical-reports-retention-rate-deposit.read": "Retention Rate(deposit)",
  "systemSetting.roles.action.plugin::user-admin-plugin.statistical-reports-retention-rate-v-three.read": "Retention Rate(V3)",


  //代理管理菜单权限管理 具体字段
  "systemSetting.roles.action.plugin::user-admin-plugin.agent-admin.read": "Agent Admin Menu",
  "systemSetting.roles.action.plugin::user-admin-plugin.agent-admin-agent-approval.read": "Agent Approval",
  "systemSetting.roles.action.plugin::user-admin-plugin.agent-admin-agent-history.read": "Agent Historyl",
  "systemSetting.roles.action.plugin::user-admin-plugin.agent-admin-agent-details.read": "Agent Details",
  "systemSetting.roles.action.plugin::user-admin-plugin.agent-admin-agent-report.read": "Agent Report",
  "systemSetting.roles.action.plugin::user-admin-plugin.agent-admin-agent-cashback-admin.read": "Agent Cashback Admin",

  //代理管理菜单权限管理 具体字段
  "systemSetting.roles.action.plugin::user-admin-plugin.config-section.read": "Config Section Menu",
  "systemSetting.roles.action.plugin::user-admin-plugin.config-section-adjust-app-config.read": "Adjust App Config",
  "systemSetting.roles.action.plugin::user-admin-plugin.config-section-about-admin.read": "About Admin",
  "systemSetting.roles.action.plugin::user-admin-plugin.config-section-left-menu-admin.read": "Left Menu Admin",
  "systemSetting.roles.action.plugin::user-admin-plugin.config-section-pixels-management.read": "Pixels Management",
  "systemSetting.roles.action.plugin::user-admin-plugin.config-section-airdrop-config.read": "Airdrop Config",
  "systemSetting.roles.action.plugin::user-admin-plugin.config-section-email-marketing.read": "Email Marketing",
  "systemSetting.roles.action.plugin::user-admin-plugin.config-section-message-admin.read": "Message Admin",
  "systemSetting.roles.action.plugin::user-admin-plugin.config-section-valid-bet-config.read": "Valid Bet Config",

  //代理管理菜单权限管理 具体字段
  "systemSetting.roles.action.plugin::user-admin-plugin.game-admin.read": "Game Admin Menu",
  "systemSetting.roles.action.plugin::user-admin-plugin.game-admin-games-manege.read": "Games Manege",
  "systemSetting.roles.action.plugin::user-admin-plugin.game-admin-game-actions.read": "Game Actions",
  "systemSetting.roles.action.plugin::user-admin-plugin.game-admin-tags-admin.read": "Game Tags Admin",

  //宝石商城管理菜单权限管理 具体字段
  "systemSetting.roles.action.plugin::user-admin-plugin.gem-mall-admin.read": "Gem Mall Menu",
  "systemSetting.roles.action.plugin::user-admin-plugin.gem-mall-admin-goods-type-admin.read": "Goods Type Admin",
  "systemSetting.roles.action.plugin::user-admin-plugin.gem-mall-admin-goods-admin.read": "Goods Admin",
  "systemSetting.roles.action.plugin::user-admin-plugin.gem-mall-admin-exchange-mall-admin.read": "Exchange Mall Admin",
  "systemSetting.roles.action.plugin::user-admin-plugin.gem-mall-admin-exchange-tags-admin.read": "Exchange Mall Tags Admin",

  //PWA通知管理菜单权限管理 具体字段
  "systemSetting.roles.action.plugin::user-admin-plugin.pwa-notification-admin.read": "PWA Notification Menu",
  "systemSetting.roles.action.plugin::user-admin-plugin.pwa-notification-admin-pwa-device-list.read": "PWA Device List",
  "systemSetting.roles.action.plugin::user-admin-plugin.pwa-notification-admin-list.read": "PWA Notification Admin",
  "systemSetting.roles.action.plugin::user-admin-plugin.pwa-notification-admin-task-list.read": "PWA Notification Task List",

  //支付管理菜单权限管理 具体字段
  "systemSetting.roles.action.plugin::user-admin-plugin.payment-admin.read": "Payment Admin Menu",
  "systemSetting.roles.action.plugin::user-admin-plugin.payment-admin-payment-platform-admin.read": "Payment Platform Admin",

  //PWA通知管理菜单权限管理 具体字段
  "systemSetting.roles.action.plugin::user-admin-plugin.system-setting.read": "System Setting Menu",
  "systemSetting.roles.action.plugin::user-admin-plugin.system-setting-user-admin.read": "System User Admin",
  "systemSetting.roles.action.plugin::user-admin-plugin.system-setting-roles-admin.read": "System Roles Admin",
};
